import React from 'react';
import { connect } from 'react-redux'
import { Pie, Bar } from 'react-chartjs-2';

import { capitalize } from '../../classes/lib-common';

const mapStateAsProps = state => ({
	report: state.projectInfo.report,
	summary: state.projectInfo.summary,
	vulnerableOnly: state.languagesFilter.vulnerableOnly,
	toggledLanguages: state.languagesFilter.toggledLanguages,
	security: state.projectInfo.security,
	stability: state.projectInfo.stability,
	licensing: state.projectInfo.licensing
})



class Overview extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.chartsData = {};
		this.colors = {
			crit_red: (border = false) => {
				return window.getColor( "critical" , border)
			},
			red: (border = false) => {
				return window.getColor( "high" , border)
			},
			yellow: (border = false) => {
				return window.getColor( "medium" , border)
			},
			blue: (border = false) => {
				return window.getColor( "low" , border)
			},
			green: (border = false) => {
				return window.getColor( "none", border)
			},
			grey: (border = false) => {
				return window.getColor( "exclusion", border)
			}
		}
		this.securityDataColors = {
			backgroundColor: [this.colors.crit_red(true), this.colors.red(true), this.colors.yellow(true), this.colors.blue(true), this.colors.green(true), this.colors.grey(true)],
			borderColor: [this.colors.crit_red(), this.colors.red(), this.colors.yellow(), this.colors.blue(), this.colors.green(), this.colors.grey()]
		}
		this.stabilityDataColors = {
			backgroundColor: [this.colors.green(true), this.colors.red(true), this.colors.yellow(true), this.colors.blue(true), this.colors.grey(true)],
			borderColor: [this.colors.green(), this.colors.red(), this.colors.yellow(), this.colors.blue(), this.colors.grey()]
		}
		this.licensingDataColors = {
			backgroundColor: [this.colors.green(true), this.colors.red(true), this.colors.yellow(true), this.colors.grey(true)],
			borderColor: [this.colors.green(), this.colors.red(), this.colors.yellow(), this.colors.grey()]
		}

		this.renderId = "";
	}









	preProcessChartData = (summary, domain) => {

		const pickColors = () => {
			if (domain === "security") {
				colors = JSON.parse(JSON.stringify(this.securityDataColors))
			}
			if (domain === "stability") {
				colors = JSON.parse(JSON.stringify(this.stabilityDataColors))
			}
			if (domain === "licensing") {
				colors = JSON.parse(JSON.stringify(this.licensingDataColors))
			}
		}


		const removeZerosFromSecurity = () => {
			const {keys, values, removed} =  allValues.reduce((processed, value, index) => {
				if( allKeys[index] === "none" && this.props.vulnerableOnly ){
					processed.removed.push(index)
					return processed
				}
				if ( value > 0 || (allKeys[index] === "none" && !this.props.vulnerableOnly) ) {
					processed.keys.push(allKeys[index])
					processed.values.push(value)
					return processed
				}
				processed.removed.push(index)
				return processed
			},{keys: [], values:[], removed: []})

			removed.sort((a,b)=>b-a)
			for (const index of removed) {
				colors.backgroundColor.splice(index, 1);
				colors.borderColor.splice(index, 1);
			}
			

			allKeys = keys
			allValues = values
		}
		const removeZerosFromOtherDomains = () => {
			allValues = allValues.filter((value, index) => {

				let isRemoved = false;


				if (value <= 0 && allKeys[index] === "excluded") {
					allKeys.splice(index - removed, 1);
					colors.backgroundColor.splice(index - removed, 1);
					colors.borderColor.splice(index - removed, 1);
					isRemoved = !isRemoved;
					removed++

				}
				return value > 0 || !isRemoved;
			})
		}


		const addGreenIfSecurityHasNoFields = () => {
			
			if (domain === "security" && !allValues.length) {
				colors.backgroundColor = this.colors.green(true);
				colors.borderColor = this.colors.green();
				allValues.push(0)
				allKeys.push("None")
			}
		}


		const formatLabels = () => {
			allKeys = allKeys.map(key => capitalize(key));
			if (allValues.length === 1 &&
				(allKeys[0] === "valid" || allKeys[0] === "updated") &&
				allValues[0] < 1) allValues[0] = 1;
			if (allValues.length === 1 &&
				(allKeys[0] === "none") &&
				allValues[0] < 1) allValues[0] = 1;
		}


		let allValues = Object.values(summary);
		let allKeys = Object.keys(summary);

		const securityAllValues = allValues.slice()

		let colors = {};
		pickColors();


		let removed = 0;
		if (domain === "security") removeZerosFromSecurity();
		else removeZerosFromOtherDomains();
		
		formatLabels();
		
		
		
		addGreenIfSecurityHasNoFields();


		return {
			data: {
				labels: allKeys,
				datasets: [{
					data: allValues,
					...colors,
					borderWidth: 1,
					securityAllValues
				}]
			}
		}

	}



	generateCharts = () => {



		const securitySummary = this.preProcessChartData(this.chartsData.security, "security");
		const securityValues = this.totalOfAllValues(securitySummary.data);
		const stabilitySummary = this.preProcessChartData(this.chartsData.stability, "stability");
		const licensingSummary = this.preProcessChartData(this.chartsData.licensing, "licensing");
		const licensingValues = this.totalOfAllValues(licensingSummary.data);
		const indexToCorrect = securitySummary.data.labels.indexOf("None");
		if (!this.props.vulnerableOnly) {
			if (licensingValues > 0 && securityValues < 2 && securitySummary.data.labels.length === 1) {
				securitySummary.data.datasets[0].data[indexToCorrect] = licensingValues;
			}
			else if (licensingValues === 0) {
				securitySummary.data.datasets[0].data[indexToCorrect] = 1;
			}
			else if (securityValues < 2 && securitySummary.data.labels.length > 1) {
				securitySummary.data.labels = securitySummary.data.labels.filter((label, index) => {
					if (label === "None") {
						securitySummary.data.datasets[0].data.splice(index, 1);
					}
					return label !== "None";
				})
			}
		}


		const securityChart = this.generateSecurityChart(securitySummary);
		const stabilityChart = this.generateBarsChart(stabilitySummary);
		const licensingChart = this.generateBarsChart(licensingSummary);
		this.setState({
			securityChart,
			stabilityChart,
			licensingChart,
			chartsReady: true
		})
	}
	totalOfAllValues = (data) => {
		return data.datasets[0].securityAllValues.reduce((acc, value) => acc + value, 0);
	}

	generateSecurityChart = (summary) => {

		const { data } = summary;

		const hasZeroData = data.datasets[0].data.length === 1 && data.datasets[0].data[0] === 0;
		if (hasZeroData) data.datasets[0].data[0] = 1;
		const totValues = this.totalOfAllValues(data);

		const options = {
			title: {
				position: 'bottom',
				fontStyle: 'italic',
				fontSize: 11,
				lineHeight: 0.7,
				display: !('ontouchstart' in window),
				text: `Based on total number of components found: ${totValues}`
			},
			legend: {
				position: 'right',
				align: "start",
				fullWidth: false,
				labels: {
					boxWidth: 14,
				}
			},
			responsive: true,
			maintainAspectRatio: false,
		}
		if (hasZeroData) {
			options.events = [];
		}

		return { data, options }
	}

	generateBarsChart = (summary) => {
		const { data } = summary;

		const options = {
			legend: {
				display: false
			},
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						userCallback: function (label) {
							if (Math.floor(label) === label) {
								return label;
							}
						}
					}
				}]
			},
			responsive: true,
			maintainAspectRatio: false
		}
		return { data, options };
	}







	processReport = () => {


		const getLanguages = () => {
			chartsData.languages = Object.keys(this.props.licensing.summary.byLanguage);
		}

		const countComponents = (language) => {

			chartsData.components += this.props.licensing.summary.byLanguage[language].tot;

		}
		const countSecurity = (language) => {
			try {
				const { critical, high, medium, low, exclusions, components } = this.props.security.summary.byLanguage[language];

				if (!Object.keys(chartsData.security).length) chartsData.security = {
					critical: 0, high: 0, medium: 0, low: 0, none: 0, excluded: 0
				};

				chartsData.security.critical += critical;
				chartsData.security.high += high;
				chartsData.security.medium += medium;
				chartsData.security.low += low;
				chartsData.security.excluded += exclusions;
				chartsData.security.none += isNaN(components) || components === 0 ? chartsData.components : components;
				chartsData.security.none -= critical + high + medium + low + exclusions;
				if (chartsData.security.none < 0) chartsData.security.none = 0
				// if (this.props.vulnerableOnly) chartsData.security.none = 0
			}
			catch (e) {
				console.log(e)
				return
			}



		}

		const countStability = (language) => {
			try {
				const { patch, minor, major, exclusions, components } = this.props.stability.summary.byLanguage[language];

				if (!Object.keys(chartsData.stability).length) chartsData.stability = {
					updated: 0, patch: 0, minor: 0, major: 0, excluded: 0
				};

				chartsData.stability.patch += patch;
				chartsData.stability.minor += minor;
				chartsData.stability.major += major;
				chartsData.stability.excluded += exclusions;
				chartsData.stability.updated += isNaN(components) || components === 0 ? chartsData.components : components;
				chartsData.stability.updated -= patch + minor + major + exclusions;
				if (chartsData.stability.updated < 0) chartsData.stability.updated = 0
				if (this.props.vulnerableOnly) chartsData.stability.updated = 0

			}
			catch (e) {
				return
			}

		}

		const countLicensing = (language) => {

			try {

				const { forbidden, undeclared, violationExclusions, warningExclusions, components } = this.props.licensing.summary.byLanguage[language];

				if (!Object.keys(chartsData.licensing).length) chartsData.licensing = {
					valid: 0, forbidden: 0, undeclared: 0, excluded: 0,
				};


				chartsData.licensing.forbidden += forbidden;
				chartsData.licensing.forbidden -= violationExclusions
				chartsData.licensing.undeclared += undeclared;
				chartsData.licensing.undeclared -= warningExclusions;
				chartsData.licensing.excluded += warningExclusions + violationExclusions;
				chartsData.licensing.valid += isNaN(components) || components === 0 ? chartsData.components : components;
				chartsData.licensing.valid -= forbidden + undeclared + warningExclusions + violationExclusions;
				if (chartsData.licensing.valid < 0) chartsData.licensing.valid = 0

				if (this.props.vulnerableOnly) chartsData.licensing.valid = 0
			}
			catch (e) {
				return;
			}

		}



		const chartsData = { languages: [], toggledLanguages: this.props.toggledLanguages || [], components: 0, security: {}, stability: {}, licensing: {} };
		getLanguages();
		for (const language of chartsData.languages) {
			if (chartsData.toggledLanguages.includes(language)) continue;
			countComponents(language);
		}


		for (const language of chartsData.languages) {
			if (chartsData.toggledLanguages.includes(language)) continue;
			countSecurity(language);
			countStability(language);
			countLicensing(language);
		}


		this.chartsData = chartsData;

		this.generateCharts();


	}


	getSnapshotBeforeUpdate(prevProps) {
		const hasSecuritySummaryChanged = JSON.stringify(prevProps.security.summary) !== JSON.stringify(this.props.security.summary);
		const hasStabilitySummaryChanged = JSON.stringify(prevProps.stability.summary) !== JSON.stringify(this.props.stability.summary);
		const hasLicensingSummaryChanged = JSON.stringify(prevProps.licensing.summary) !== JSON.stringify(this.props.licensing.summary);
		const hasReportChanged = hasSecuritySummaryChanged || hasStabilitySummaryChanged || hasLicensingSummaryChanged
		const hasFilterChanged = prevProps.vulnerableOnly !== this.props.vulnerableOnly || prevProps.toggledLanguages.toString() !== this.props.toggledLanguages.toString();

		return hasReportChanged || hasFilterChanged
	}

	componentDidUpdate(prevProps, prevState, didUpdate) {
		if (didUpdate) {
			this.processReport();
		}
	}


	componentDidMount() {
		window.$('body').click(() => window.$(".popover").popover("hide"))
		this.processReport();
	}

	render() {
		const { securityChart, stabilityChart, licensingChart } = this.state;

		if (!this.props.ready) return null
		if (this.chartsData && this.chartsData.components === 0) return ""

		if (!this.state.chartsReady) return ""

		return !this.props.collapsed ?
			<div className="row">
				<div className="col-md-12" id="charts">
					<div className="report-box">
						{this.props.ready.security ?
							<div className="chart-wrapper position-relative text-center">
								<h5><span className="badge badge-light badge-security-chart">Security</span></h5>
								<Pie data={securityChart.data} options={securityChart.options} />
								<div id="legend-title">Threat Level</div>
							</div> : ""
						}
						{this.props.ready.stability ?
							<div className="chart-wrapper position-relative text-center">
								<h5><span className="badge badge-light">Stability</span></h5>
								<Bar data={stabilityChart.data} options={stabilityChart.options} />
							</div> : ""
						}
						{this.props.ready.licensing ?
							<div className="chart-wrapper position-relative text-center">
								<h5><span className="badge badge-light">Licensing</span></h5>
								<Bar data={licensingChart.data} options={licensingChart.options} />
							</div> : ""
						}


					</div>
				</div>
			</div> :
			<div className="w-100 charts-collapsed row">
				{this.props.ready.security ?
					<div className="chart-wrapper position-relative text-center">
						<h5><span className="badge badge-light badge-security-chart">Security</span></h5>
						<Pie data={securityChart.data} options={securityChart.options} />
						<div id="legend-title">Threat Level</div>
					</div> : ""
				}
				{this.props.ready.stability ?
					<div className="chart-wrapper position-relative text-center">
						<h5><span className="badge badge-light">Stability</span></h5>
						<Bar data={stabilityChart.data} options={stabilityChart.options} />
					</div> : ""
				}
				{this.props.ready.licensing ?
					<div className="chart-wrapper position-relative text-center">
						<h5><span className="badge badge-light">Licensing</span></h5>
						<Bar data={licensingChart.data} options={licensingChart.options} />
					</div> : ""
				}
			</div>


	}
}

export default connect(mapStateAsProps)(Overview);